export const orderFetchMixin = {
  // Add into the component in the "created" hook:
  // created() {
  //   this.fetchOrder(this.currentOrderId, this.getFreshOrder)
  // },

  computed: {
    currentOrderId() {
      return this.$route.params.uuid || this.$route.params.order_id
    },
    currentReservationId() {
      return this.$route.params.reservation_id
    },
    // To get fresh order, override this computed into the component setting it to true
    getFreshOrder() {
      return false
    },
    reservation() {
      return this.order?.reservations?.find(reservation => {
        return reservation.id == this.currentReservationId
      })
    },
  },

  methods: {
    fetchOrder(order_id, fresh = this.getFreshOrder) {
      return this.$store
        .dispatch('order/fetchOrder', { id: order_id, fresh: fresh })
        .then(() => {
          // set current reservation to store, taken from url param
          this.$store.dispatch('order/setReservationId', this.reservation?.id).then(() => {
            // check steps state after order fetch
            this.$store.dispatch('layout/checkSteps')
          })
        })
        .catch(error => {
          if (!!error && ![500, 401, 502, 503, 504].includes(error.status)) {
            this.$router.push({ name: 'dashboard' })
            this.$store.dispatch('layout/replaceAlert', {
              type: 'error',
              key: 'order_not_found',
            })
          }
          console.log(`Cannot fetch order id ${order_id}: ${error}`)
        })
    },
    /*fetchOrderToUpdateReservation(order_id) {
      return this.$store
        .dispatch('order/fetchOrderToUpdateReservation', order_id)
        .then(reservation => {
          // console.log(`mixin order/fetchOrderToUpdateReservation order ${order_id} to update reservation ${reservation.id}`)
          // check steps state after order fetch
          this.$store.dispatch('layout/checkSteps')
        }).catch(error => {
          if (!!error && ![500, 401, 502, 503, 504].includes(error.status)) {
            this.$store.dispatch('layout/replaceAlert', {
              type: 'error',
              key: 'order_not_found',
            })
          }
          console.log(`Error order/fetchOrderToUpdateReservation order ${order_id}: ${error}`)
        })
    },*/
  },
}
